'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _URLInput = require('./components/URLInput.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_URLInput).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/url-input/index.js
// module id = 1057
// module chunks = 0